import type { ReactNode } from "react";
import { Link } from "react-router";

type SocialLink = {
  name: string;
  href: string;
  icon: ReactNode;
};

const SOCIAL_LINKS: SocialLink[] = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/scribenote.inc/",
    icon: (
      <svg
        viewBox="0 0 640 640"
        fill="currentColor"
        aria-hidden="true"
        className="block h-6 w-6"
      >
        <path d="M320.3 205C256.8 204.8 205.2 256.2 205 319.7C204.8 383.2 256.2 434.8 319.7 435C383.2 435.2 434.8 383.8 435 320.3C435.2 256.8 383.8 205.2 320.3 205zM319.7 245.4C360.9 245.2 394.4 278.5 394.6 319.7C394.8 360.9 361.5 394.4 320.3 394.6C279.1 394.8 245.6 361.5 245.4 320.3C245.2 279.1 278.5 245.6 319.7 245.4zM413.1 200.3C413.1 185.5 425.1 173.5 439.9 173.5C454.7 173.5 466.7 185.5 466.7 200.3C466.7 215.1 454.7 227.1 439.9 227.1C425.1 227.1 413.1 215.1 413.1 200.3zM542.8 227.5C541.1 191.6 532.9 159.8 506.6 133.6C480.4 107.4 448.6 99.2 412.7 97.4C375.7 95.3 264.8 95.3 227.8 97.4C192 99.1 160.2 107.3 133.9 133.5C107.6 159.7 99.5 191.5 97.7 227.4C95.6 264.4 95.6 375.3 97.7 412.3C99.4 448.2 107.6 480 133.9 506.2C160.2 532.4 191.9 540.6 227.8 542.4C264.8 544.5 375.7 544.5 412.7 542.4C448.6 540.7 480.4 532.5 506.6 506.2C532.8 480 541 448.2 542.8 412.3C544.9 375.3 544.9 264.5 542.8 227.5zM495 452C487.2 471.6 472.1 486.7 452.4 494.6C422.9 506.3 352.9 503.6 320.3 503.6C287.7 503.6 217.6 506.2 188.2 494.6C168.6 486.8 153.5 471.7 145.6 452C133.9 422.5 136.6 352.5 136.6 319.9C136.6 287.3 134 217.2 145.6 187.8C153.4 168.2 168.5 153.1 188.2 145.2C217.7 133.5 287.7 136.2 320.3 136.2C352.9 136.2 423 133.6 452.4 145.2C472 153 487.1 168.1 495 187.8C506.7 217.3 504 287.3 504 319.9C504 352.5 506.7 422.6 495 452z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/scribenote",
    icon: (
      <svg
        viewBox="0 0 640 640"
        fill="currentColor"
        aria-hidden="true"
        className="block h-6 w-6"
      >
        <path d="M576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 440 146.7 540.8 258.2 568.5L258.2 398.2L205.4 398.2L205.4 320L258.2 320L258.2 286.3C258.2 199.2 297.6 158.8 383.2 158.8C399.4 158.8 427.4 162 438.9 165.2L438.9 236C432.9 235.4 422.4 235 409.3 235C367.3 235 351.1 250.9 351.1 292.2L351.1 320L434.7 320L420.3 398.2L351 398.2L351 574.1C477.8 558.8 576 450.9 576 320z" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/scribenote/",
    icon: (
      <svg
        viewBox="0 0 640 640"
        fill="currentColor"
        aria-hidden="true"
        className="block h-6 w-6"
      >
        <path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM165 266.2L231.5 266.2L231.5 480L165 480L165 266.2zM236.7 198.5C236.7 219.8 219.5 237 198.2 237C176.9 237 159.7 219.8 159.7 198.5C159.7 177.2 176.9 160 198.2 160C219.5 160 236.7 177.2 236.7 198.5zM413.9 480L413.9 376C413.9 351.2 413.4 319.3 379.4 319.3C344.8 319.3 339.5 346.3 339.5 374.2L339.5 480L273.1 480L273.1 266.2L336.8 266.2L336.8 295.4L337.7 295.4C346.6 278.6 368.3 260.9 400.6 260.9C467.8 260.9 480.3 305.2 480.3 362.8L480.3 480L413.9 480z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@scribenote.inc",
    icon: (
      <svg
        viewBox="0 0 640 640"
        fill="currentColor"
        aria-hidden="true"
        className="block h-6 w-6"
      >
        <path d="M544.5 273.9C500.5 274 457.5 260.3 421.7 234.7L421.7 413.4C421.7 446.5 411.6 478.8 392.7 506C373.8 533.2 347.1 554 316.1 565.6C285.1 577.2 251.3 579.1 219.2 570.9C187.1 562.7 158.3 545 136.5 520.1C114.7 495.2 101.2 464.1 97.5 431.2C93.8 398.3 100.4 365.1 116.1 336C131.8 306.9 156.1 283.3 185.7 268.3C215.3 253.3 248.6 247.8 281.4 252.3L281.4 342.2C266.4 337.5 250.3 337.6 235.4 342.6C220.5 347.6 207.5 357.2 198.4 369.9C189.3 382.6 184.4 398 184.5 413.8C184.6 429.6 189.7 444.8 199 457.5C208.3 470.2 221.4 479.6 236.4 484.4C251.4 489.2 267.5 489.2 282.4 484.3C297.3 479.4 310.4 469.9 319.6 457.2C328.8 444.5 333.8 429.1 333.8 413.4L333.8 64L421.8 64C421.7 71.4 422.4 78.9 423.7 86.2C426.8 102.5 433.1 118.1 442.4 131.9C451.7 145.7 463.7 157.5 477.6 166.5C497.5 179.6 520.8 186.6 544.6 186.6L544.6 274z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@scribenote",
    icon: (
      <svg
        viewBox="0 0 640 640"
        fill="currentColor"
        aria-hidden="true"
        className="block h-6 w-6"
      >
        <path d="M581.7 188.1C575.5 164.4 556.9 145.8 533.4 139.5C490.9 128 320.1 128 320.1 128C320.1 128 149.3 128 106.7 139.5C83.2 145.8 64.7 164.4 58.4 188.1C47 231 47 320.4 47 320.4C47 320.4 47 409.8 58.4 452.7C64.7 476.3 83.2 494.2 106.7 500.5C149.3 512 320.1 512 320.1 512C320.1 512 490.9 512 533.5 500.5C557 494.2 575.5 476.3 581.8 452.7C593.2 409.8 593.2 320.4 593.2 320.4C593.2 320.4 593.2 231 581.8 188.1zM264.2 401.6L264.2 239.2L406.9 320.4L264.2 401.6z" />
      </svg>
    ),
  },
];

const PAGE_LINKS = [
  { label: "Home", to: "/" },
  { label: "Pricing", to: "/pricing" },
  { label: "Use cases", to: "/use-cases" },
  { label: "Blog", to: "/blog" },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-grindigo-100 px-[clamp(24px,5vw,80px)] pt-12 pb-8">
      <div className="mx-auto max-w-[1240px]">
        <div className="grid grid-cols-1 items-center gap-y-6 md:grid-cols-[1fr_auto_1fr] md:gap-x-8">
          <div className="flex items-center justify-center gap-4 md:justify-start">
            <a
              href="https://trust.scribenote.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="SOC 2 Type II compliant — powered by Vanta"
              className="inline-block transition-transform duration-150 ease-[ease] hover:-translate-y-px"
            >
              <img
                src="/vanta-soc2-badge.png"
                alt="SOC 2 Type II compliant — powered by Vanta"
                width={64}
                height={64}
                className="block h-16 w-16"
              />
            </a>
            <a
              href="https://trust.scribenote.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="ISO/IEC 42001 certified"
              className="inline-block transition-transform duration-150 ease-[ease] hover:-translate-y-px"
            >
              <img
                src="/iso-iec-42001-badge.png"
                alt="ISO/IEC 42001 certified"
                width={64}
                height={64}
                className="block h-16 w-16"
              />
            </a>
          </div>
          <nav
            aria-label="Footer"
            className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2"
          >
            {PAGE_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-medium text-secondary no-underline transition-colors duration-150 ease-[ease] hover:text-indigo-600"
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <ul className="flex items-center justify-center gap-1 md:justify-end">
            {SOCIAL_LINKS.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Scribenote on ${link.name}`}
                  className="grid h-12 w-12 place-items-center rounded-full text-secondary transition-[color,background,transform] duration-150 ease-[ease] hover:bg-indigo-50 hover:text-indigo-600 hover:-translate-y-px"
                >
                  {link.icon}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-8 text-center text-[13px] text-secondary">
          © {year}{" "}
          <a
            href="https://www.scribenote.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-inherit"
          >
            Scribenote
          </a>{" "}
          · Made with 💜 in 🇨🇦 ·{" "}
          <a
            href="https://www.scribenote.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-inherit"
          >
            Privacy
          </a>{" "}
          ·{" "}
          <a
            href="https://www.scribenote.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className="text-inherit"
          >
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
}
